import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-5 pt-40 pb-24" data-testid="notfound-page">
      <Seo
        title="Page Not Found | Saver Plus Lighting Corp"
        description="The page you're looking for can't be found. Explore our lighting and electrical products or contact Saver Plus Lighting Corp in Toronto."
        path="/404"
        index={false}
      />
      <div className="max-w-xl text-center">
        <p className="font-display text-gold text-7xl md:text-8xl leading-none">404</p>
        <h1 className="mt-6 font-display uppercase text-3xl md:text-4xl tracking-tight leading-[0.95]">
          Page not found
        </h1>
        <p className="mt-5 text-white/60 leading-relaxed">
          The page you're looking for may have moved or no longer exists. Try one of these instead:
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center gap-2 bg-gold text-white text-sm uppercase tracking-[0.14em] font-semibold px-6 py-3.5 hover:bg-[#b00000] transition-colors duration-300"
          >
            Back to Home <ArrowUpRight className="w-4 h-4" />
          </Link>
          <Link
            to="/products"
            data-testid="notfound-products-link"
            className="link-sweep inline-flex items-center gap-2 text-sm uppercase tracking-[0.14em] text-white/80 hover:text-white transition-colors duration-300"
          >
            Browse Products
          </Link>
          <Link
            to="/contact"
            data-testid="notfound-contact-link"
            className="link-sweep inline-flex items-center gap-2 text-sm uppercase tracking-[0.14em] text-white/80 hover:text-white transition-colors duration-300"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
